import React from 'react'
import { useLanguage } from '@/contexts/LanguageContext'
import { SupportedLanguage } from '@/i18n'

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage()

  const toggleLanguage = () => {
    const newLang: SupportedLanguage = language === 'en' ? 'fr' : 'en'
    setLanguage(newLang)
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-1 px-2 py-1 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition-colors"
      aria-label={language === 'en' ? 'Switch to French' : 'Switch to English'}
    >
      <span className="text-base">{language === 'en' ? 'EN' : 'FR'}</span>
    </button>
  )
}

export default LanguageToggle
